import DevEnvironmentsGuardContainer from './DevEnvironmentsGuardContainer';

export default DevEnvironmentsGuardContainer;
